import { Translation } from '@ngneat/transloco';
import { TableColumnDef } from '../../../../../../../../../projects/grid-views/src/public-api';
import { FieldProps } from 'app/data-api';

export default function getDisplayedFieldColumns(
    translocoContent: Translation
): Array<TableColumnDef> {
    return [
        {
            columnName: translocoContent['fieldFields.tableName'],
            columnKey: FieldProps.table_name,
            contentType: 'string',
            enableSorting: true,
        },
        {
            columnName: translocoContent['fieldFields.fieldName'],
            columnKey: FieldProps.field_name,
            contentType: 'string',
            enableSorting: true,
        },
        {
            columnName: translocoContent['fieldFields.fieldTitle'],
            columnKey: FieldProps.field_title,
            contentType: 'string',
            enableSorting: true,
        },
        {
            columnName: translocoContent['fieldFields.dataElement'],
            columnKey: FieldProps.dataElement,
            contentType: 'string',
            enableSorting: true,
        },
        {
            columnName: translocoContent['fieldFields.component'],
            columnKey: FieldProps.component,
            contentType: 'string',
            enableSorting: true,
        },
        {
            columnName: translocoContent['fieldFields.domain'],
            columnKey: FieldProps.domain,
            contentType: 'string',
            enableSorting: true,
        },
        {
            columnName: translocoContent['fieldFields.dataType'],
            columnKey: FieldProps.dataType,
            contentType: 'string',
            enableSorting: true,
        },
        {
            columnName: translocoContent['fieldFields.dataTypes'],
            columnKey: FieldProps.dataTypes,
            contentType: 'string',
            enableSorting: true,
        },
        {
            columnName: translocoContent['fieldFields.heading'],
            columnKey: FieldProps.heading,
            contentType: 'string',
            enableSorting: true,
        },
        {
            columnName: translocoContent['fieldFields.headingLength'],
            columnKey: FieldProps.headingLength,
            contentType: 'string',
            enableSorting: true,
        },
        {
            columnName: translocoContent['fieldFields.length'],
            columnKey: FieldProps.length,
            contentType: 'string',
            enableSorting: true,
        },
        {
            columnName: translocoContent['fieldFields.longFieldLabel'],
            columnKey: FieldProps.longFieldLabel,
            contentType: 'string',
            enableSorting: true,
        },
        {
            columnName: translocoContent['fieldFields.longFieldLabelLength'],
            columnKey: FieldProps.longFieldLabelLength,
            contentType: 'string',
            enableSorting: true,
        },
        {
            columnName: translocoContent['fieldFields.mediumFieldLabel'],
            columnKey: FieldProps.mediumFieldLabel,
            contentType: 'string',
            enableSorting: true,
        },
        {
            columnName: translocoContent['fieldFields.mediumFieldLabelLength'],
            columnKey: FieldProps.mediumFieldLabelLength,
            contentType: 'string',
            enableSorting: true,
        },
        {
            columnName: translocoContent['fieldFields.noChar'],
            columnKey: FieldProps.noChar,
            contentType: 'string',
            enableSorting: true,
        },
        {
            columnName: translocoContent['fieldFields.status'],
            columnKey: FieldProps.status,
            contentType: 'string',
            enableSorting: true,
        },
        {
            columnName: translocoContent['fieldFields.system'],
            columnKey: FieldProps.system,
            contentType: 'string',
            enableSorting: true,
        },
        {
            columnName: translocoContent['fieldFields.valueTable'],
            columnKey: FieldProps.valueTable,
            contentType: 'string',
            enableSorting: true,
        },
        {
            columnName: translocoContent['fieldFields.shortDescription'],
            columnKey: FieldProps.shortDescription,
            contentType: 'string',
            enableSorting: true,
        },
        {
            columnName: translocoContent['fieldFields.shortFieldLabel'],
            columnKey: FieldProps.shortFieldLabel,
            contentType: 'string',
            enableSorting: true,
        },
        {
            columnName: translocoContent['fieldFields.shortFieldLabelLength'],
            columnKey: FieldProps.shortFieldLabelLength,
            contentType: 'string',
            enableSorting: true,
        },
        {
            columnName: translocoContent['fieldFields.description'],
            columnKey: FieldProps.description,
            contentType: 'string',
            enableSorting: true,
        },
    ];
}
